import React from 'react'
import CSSTransitionGroup from 'react-addons-css-transition-group'
import FlashMessage from './FlashMessage'
import update from 'immutability-helper'
import propTypes from 'prop-types'

export default class FlashMessageList extends React.Component {
  constructor (props) {
    super(props)
    this.state = { messages: props.messages }

    window.flash_messages = this
  }

  addMessage (message) {
    const messages = update(this.state.messages, { $push: [message] })
    this.setState({ messages: messages })
  }

  removeMessage (message) {
    const index = this.state.messages.indexOf(message)
    const messages = update(this.state.messages, { $splice: [[index, 1]] })
    this.setState({ messages: messages })
  }

  render () {
    const alerts = this.state.messages && this.state.messages.map(message =>
      <FlashMessage key={message.id} message={message}
        onClose={() => this.removeMessage(message)} />
    )

    return (
      <CSSTransitionGroup
        style={{position: 'fixed', top: '120px', right: '20px'}}
        transitionName='alerts'
        transitionEnter={false}
        transitionLeaveTimeout={500}>
        { alerts }
      </CSSTransitionGroup>
    )
  }
}

FlashMessageList.defaultProps = {
  messages: []
}

FlashMessageList.propTypes = {
  messages: propTypes.array
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/flashMessages/FlashMessageList.js